export default __webpack_public_path__ + "static/save-f4eb87d6253e7894faf7b8d28852d0d7.svg";